import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordComplexityValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value ?? '';
  if (!value) {
    return null;
  }

  const errors: ValidationErrors = {};

  if (!/[a-z]/.test(value)) {
    errors['passwordRequiresLower'] = true;
  }
  if (!/[A-Z]/.test(value)) {
    errors['passwordRequiresUpper'] = true;
  }
  if (!/[0-9]/.test(value)) {
    errors['passwordRequiresDigit'] = true;
  }
  if (!/[^0-9a-zA-Z]/.test(value)) {
    errors['passwordRequiresNonAlphanumeric'] = true;
  }

  return Object.keys(errors).length ? errors : null;
}
